var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Access My Data Records ")]),
      _c(
        "gg-card-text",
        [
          _c("h4", [_vm._v("Your Personal Profile")]),
          _c("p", [
            _vm._v(
              "Get access to your personal information in a machine readable format."
            )
          ]),
          _c(
            "gg-btn",
            {
              staticClass: "ml-0",
              attrs: {
                secondary: "",
                elevation: "0",
                loading: _vm.loading
              },
              on: {
                click: function click($event) {
                  _vm.confirmationModal = true
                }
              }
            },
            [
              _vm._v(" Access My Records "),
              _c(
                "span",
                {
                  staticClass: "visually-hidden text-lowercase"
                },
                [_vm._v("button")]
              )
            ]
          )
        ],
        1
      ),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.confirmationModal,
          "max-width": "350"
        },
        on: {
          close: function close($event) {
            _vm.confirmationModal = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Request My Data Records ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("gg-card-text", [
                  _vm._v(
                    " Please confirm you wish to request your data. This process may take up to 24 hours. "
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      secondary: ""
                    },
                    on: {
                      click: function click($event) {
                        _vm.confirmationModal = false
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      loading: _vm.loading
                    },
                    on: {
                      click: _vm.accessMyRecords
                    }
                  },
                  [_vm._v("Confirm")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }